import { gql } from '@provision/graphql-client';

export const USER_SETTING_VALUE_FRAGMENT = gql`
  fragment UserSettingValueFields on UserSettingValue {
    id
    value
    userId
    valueType
    partnerId
    userSettingId
  }
`;
